import * as React from "react";
import MenuItem from "material-ui/MenuItem";
import { List } from "immutable";
import { formatMessage } from "lib/globalize-util";
import classNames from "classnames";
import { ISavedView, SavedView } from "./saved-view";
import { Accordion } from "./accordion";
import { DATATEST } from "constants/integration";
import {
    CollectionSavedViewRollupSeparator,
    ReviewTabSavedViewRollupSeparator,
} from "../product-collection-grid-view/tool-panels";

export interface ISavedViewsByCollection {
    id: string;
    title: string;
    views: ISavedView[];
}

interface IProps {
    currentViewId: string;
    onLoad: (viewName: string, viewId: string, viewIndex: number, collectionId: string) => void;
    schemaIdWithRemovedFields: string;
    handleLoadDefaultMaster: () => void;
    onOpenRemovedFieldModal: (event) => void;
    editable: boolean;
    isDefaultMasterViewActive: boolean;
    items: ISavedViewsByCollection[];
    merchantItems?: List<ISavedView>;
    isReviewTab: boolean;
}

export const SavedViewsByCollection: React.FunctionComponent<IProps> = ({
    currentViewId,
    schemaIdWithRemovedFields,
    onLoad,
    handleLoadDefaultMaster,
    onOpenRemovedFieldModal,
    editable,
    isDefaultMasterViewActive,
    items,
    merchantItems,
    isReviewTab = false,
}) => {
    const handleLoad = (collectionId: string) => (viewName: string, viewId: string, viewIndex: number) => {
        onLoad(viewName, viewId, viewIndex, collectionId);
    };

    return (
        <>
            <MenuItem
                data-test={DATATEST.ASSORTMENTS.ROLLUP_DEFAULT_VIEW_MASTER}
                onClick={handleLoadDefaultMaster}
                className={classNames("view", { selectedView: isDefaultMasterViewActive })}
            >
                <div className="viewEntry">
                    <div className="viewName">{formatMessage("Default")}</div>
                </div>
            </MenuItem>
            {merchantItems && merchantItems.size > 0 && (
                <Accordion
                    title={formatMessage("Merchant Saved Views")}
                    dataTestId={DATATEST.ASSORTMENTS.ROLLUP_ACCORDION_MENU}
                >
                    {merchantItems.map((savedView, index) => (
                        <SavedView
                            key={savedView.id}
                            view={savedView}
                            onLoad={handleLoad(undefined)}
                            schemaIdWithRemovedFields={schemaIdWithRemovedFields}
                            onOpenRemovedFieldModal={onOpenRemovedFieldModal}
                            viewIndex={index}
                            editable={editable}
                            isActive={currentViewId === savedView.id}
                            isMerchantSavedView={true}
                        />
                    ))}
                </Accordion>
            )}
            {items.map((viewListItem) => (
                <Accordion key={viewListItem.id} title={viewListItem.title}>
                    {viewListItem.views.map((savedView, index) => {
                        let isSavedViewActive = false;

                        if (currentViewId) {
                            const [selectedViewId, selectedCollectionId] = currentViewId.split(
                                isReviewTab ? ReviewTabSavedViewRollupSeparator : CollectionSavedViewRollupSeparator
                            );
                            isSavedViewActive =
                                selectedCollectionId === viewListItem.id && selectedViewId === savedView.id;
                        }

                        return (
                            <SavedView
                                key={savedView.id}
                                view={savedView}
                                onLoad={handleLoad(viewListItem.id)}
                                schemaIdWithRemovedFields={schemaIdWithRemovedFields}
                                onOpenRemovedFieldModal={onOpenRemovedFieldModal}
                                viewIndex={index}
                                editable={editable}
                                isActive={isSavedViewActive}
                                isMerchantSavedView={false}
                            />
                        );
                    })}
                </Accordion>
            ))}
        </>
    );
};
